import React from "react";
import ReactGA from "react-ga";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import firebase from "firebase/app";

let config = {
  apiKey: process.env.REACT_APP_API_KEY, 
  authDomain: process.env.REACT_APP_AUTH_DOMAIN,
  databaseURL: process.env.REACT_APP_DATABASE_URL,
  projectId: process.env.REACT_APP_PROJECT_ID,
  storageBucket: process.env.REACT_APP_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_APP_ID,
}

if (process.env.REACT_APP_ENV === 'staging') {
  config.measurementId = process.env.REACT_APP_MEASUREMENT_ID
}

firebase.initializeApp(config);

if (process.env.NODE_ENV === 'production' && process.env.CIRCLE_CI_ENV === 'production') {
  ReactGA.initialize("UA-150586245-2");  
}

ReactDOM.render(
  <App />,
  document.getElementById("root")
);

serviceWorker.unregister();
